module.exports = "/fonts/Cabin-SemiBoldItalic.ttf";